import { SubHeading } from '../common/subHeading';
import {
  ClosedBtn,
  LiveBtn,
  UpcomingBtn,
} from '../nfoPage/nfoStates/nfoStates';

export const NfoOverview = ({
  nfoState,
  nfoCloseDate,
  nfoCloseDay,
  nav,
  allotmentDate,
  openDate,
}) => {
  return (
    <div className="lil-mt-12 sm:lil-mt-6">
      <SubHeading title="Fund overview" />
      <div
        className="lil-flex lil-justify-between lil-p-10 sm:lil-p-2 lil-rounded-t-lg lil-relative lil-mt-12 sm:lil-mt-6"
        style={{
          background: `${
            nfoState.nfoState === 'LIVE'
              ? '#F7FCFA'
              : nfoState.nfoState === 'UPCOMING'
              ? '#EEF5FF'
              : '#FFFBF5'
          }`,
        }}
      >
        {nfoState.nfoState === 'LIVE' ? (
          <LiveBtn style={{ top: '-15px' }} className="lil-absolute" />
        ) : nfoState.nfoState === 'UPCOMING' ? (
          <UpcomingBtn style={{ top: '-15px' }} className="lil-absolute" />
        ) : (
          <ClosedBtn style={{ top: '-15px' }} className="lil-absolute" />
        )}

        <div className="lil-align-middle lil-mt-5 lil-w-1/2">
          <p className="lil-text-base sm:lil-text-s-12 lil-mb-2">
            Last date to invest
          </p>
          <div className="lil-font-bold">
            <p className="lil-text-s-24 lil-text-font-500 sm:lil-text-base lil-font-bold">
              {nfoCloseDate}
            </p>
            <p className="lil-text-font-500 sm:lil-text-s-12">{nfoCloseDay}</p>
          </div>
        </div>
        <div className="lil-w-1/2">
          <div className="lil-border-b-sm lil-border-dashed sm:lil-border-none lil-border-grey-380 lil-flex lil-p-2 lil-justify-between">
            <p className="sm:lil-text-s-12 lil-text-base ">Offer price</p>
            <p className="lil-font-bol lil-font-bold lil-text-font-500 sm:lil-text-s-12 ">
              ₹{nav}
            </p>
          </div>
          <div className="lil-border-b-sm lil-border-dashed sm:lil-border-none lil-border-grey-380 lil-flex lil-p-2 lil-justify-between">
            <p className="sm:lil-text-s-12 lil-text-base ">Allotment date</p>
            <p className="lil-font-bol lil-font-bold lil-text-font-500 sm:lil-text-s-12">
              {allotmentDate}
            </p>
          </div>
          <div className="lil-border-b-sm lil-border-dashed sm:lil-border-none lil-border-grey-380 lil-flex lil-p-2 lil-justify-between">
            <p className="sm:lil-text-s-12 lil-text-base ">Launch date</p>
            <p className="lil-font-bol lil-font-bold lil-text-font-500 sm:lil-text-s-12">
              {openDate}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/nfoOverview.tsx